/**
 * Primary-edge line helpers: edge orientation, the corner chamfer insets at an
 * edge's ends, and the primary edge's LineFrame and its transforms.
 */
import { EdgeName, FloorPlanRoom, Point, roomCorner } from '../schemas';
import { alongLeg, edgeFrame, lineCoords, LineFrame, worldOnLine } from './frames';

export function isHorizontal(edge: EdgeName): boolean {
  return edge === 'backEdge' || edge === 'frontEdge';
}

/** How far the corner chamfer at the edge's start (or end) cuts into the edge. */
export function edgeLeg(s: FloorPlanRoom, edge: EdgeName, atStart: boolean): number {
  const fr = edgeFrame(edge, s.width, s.length);
  return alongLeg(roomCorner(s, atStart ? fr.startCorner : fr.endCorner), fr.horizontal);
}

export function primaryEdgeLineFrame(s: FloorPlanRoom, edge: EdgeName): LineFrame {
  const { start, end, dir, perp, length } = edgeFrame(edge, s.width, s.length);
  return { start, end, dir, perp, length };
}

/** The room point at `along` the primary edge from its start and `out` beyond it. */
export function edgeWorld(shape: FloorPlanRoom, edge: EdgeName, along: number, out: number): Point {
  return worldOnLine(edgeFrame(edge, shape.width, shape.length), along, out);
}

/** @deprecated The edge frame's `lineCoords` as `{ s, o }`, kept while the editor core re-exports it. */
export function localCoords(shape: FloorPlanRoom, edge: EdgeName, p: Point): { s: number; o: number } {
  const { along, out } = lineCoords(edgeFrame(edge, shape.width, shape.length), p);
  return { s: along, o: out };
}
